<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import UsefulLinks from '@/components/UsefulLink/UsefulLinks.vue'
import type { UsefulLink } from '@/components/UsefulLink/UsefulLink.types'

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

const links: UsefulLink[] = [
  {
    title: 'Komisja Nadzoru Finansowego',
    url: 'https://www.knf.gov.pl',
  },
  {
    title: 'Giełda Papierów Wartościowych',
    url: 'https://www.gpw.pl',
  },
  {
    title: 'Stowarzyszenie Emitentów Giełdowych',
    url: 'https://www.seg.org.pl',
  },
  {
    title: 'Stowarzyszenie Inwestorów Indywidualnych',
    url: 'https://www.sii.org.pl',
  },
]

useHead(() => ({
  title: t('pageTitles.investorUsefulLinks.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorUsefulLinks.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorUsefulLinks.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorUsefulLinks.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorUsefulLinks.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorUsefulLinks.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div class="usefulLinksPage">
    <InvestorHero
      class="usefulLinksPage__hero"
      :title="$t('investor.usefulLinksPage.title')"
      :lead="$t('investor.usefulLinksPage.lead')"
      :main-category="{
        label: $t('investor.usefulLinksPage.mainCategory.label'),
        url: $t('investor.usefulLinksPage.mainCategory.url'),
        aria: $t('investor.usefulLinksPage.mainCategory.label'),
      }"
      image="/images/investor/hero/useful-links.png"
    />

    <UsefulLinks :links="links" />
  </div>
</template>
